import React, { useState } from "react";
import { Form, FormGroup, Label, Input, Button, Spinner } from "reactstrap";
import { Link, useParams } from "react-router-dom";
import { Eye, EyeOff } from "react-feather";
import classNames from "classnames";

import Logo from "~/assets/images/login/login-logo.svg";

import ValidationGroup, { ValidatorMark } from "~/components/validation";

import getRecaptcha from "../_services/recaptcha";
import security     from "~/services/security";


const ResetForm = (props)=> {

  const defaultCredentials = {
    password        : "",
    confirmPassword : ""
  };

  const [credentials           , setCredentials]           = useState(defaultCredentials);

  const [loading               , setLoading]               = useState(false);
  const [togglePassword        , setTogglePassword]        = useState(false);
  const [toggleConfirmPassword , setToggleConfirmPassword] = useState(false);

  const [errors                , setErrors]                = useState({});

  const { token }  = useParams();
  const validation = ValidationGroup("ForgotPassword");

  const changeProp = (prop, value)=> setCredentials({...credentials, [prop]: value});

  const hasErrors = ()=> {

    const errorList = {
      ...validation("password"        , credentials.password       , {match: credentials.confirmPassword}),
      ...validation("confirmPassword" , credentials.confirmPassword, {match: credentials.password})
    };
    setErrors(errorList);

    return Boolean(Object.keys(errorList).length);
  };

  const submitChangePassword = async (e)=> {

    e.preventDefault();
    if(hasErrors()) return;
    setLoading(true);

    const recaptcha = await getRecaptcha();

    return security.resetPassword(token, { ...credentials, recaptcha })
      .then((message)=> props.history.push({pathname: "/login", message: {text: message, type: "success"}}))
      .catch(setErrors)
      .finally(()=> setLoading(false));
  };

  return (
    <div className="login-card">
      <div>

        <Link to={"/login"} className="logo"> <img src={Logo} /> </Link>

        <div className="login-main">
          <Form className="theme-form text-center" onSubmit={submitChangePassword}>

            <h3 className='greeting'> Enter Your New Password </h3>
            { errors.generalError && <p className='text-danger'>{ errors.generalError } </p> }

            <FormGroup>
              <Label className="col-form-label">New Password</Label>
              <Input type={togglePassword ? "text" : "password"}
                value={credentials.password}
                onChange={(e)=> changeProp('password', e.target.value)}
                className={classNames({ 'is-invalid': errors.password })}
                placeholder="*********"
              />
              <div className="validation-mark" onClick={() => setTogglePassword(!togglePassword)} >
                { togglePassword ? <Eye color="var(--theme-deafult)"/> : <EyeOff  color="var(--theme-deafult)" /> }
              </div>

              <ValidatorMark val={credentials.password} name="password" validation={validation} errors={errors} textOnly={true} />
            </FormGroup>

            <FormGroup>
              <Label className="col-form-label">Retype Password</Label>
              <Input type={toggleConfirmPassword ? "text" : "password"}
                value={credentials.confirmPassword}
                onChange={(e)=> changeProp('confirmPassword', e.target.value) }
                className={classNames({ 'is-invalid': errors.confirmPassword})}
                placeholder="*********"
              />
              <div className="validation-mark" onClick={() => setToggleConfirmPassword(!toggleConfirmPassword) } >
                { toggleConfirmPassword ? <Eye color="var(--theme-deafult)"/> : <EyeOff  color="var(--theme-deafult)" /> }
              </div>

              <ValidatorMark val={credentials.confirmPassword} name="confirmPassword" validation={validation} errors={errors} textOnly={true} />
            </FormGroup>

            <FormGroup className="m-t-30 m-b-30">
              <Button color="login" className="btn-block" disabled={loading} type="submit">
                { loading ? <Spinner size="sm"></Spinner> : "Done" }
               </Button>
            </FormGroup>

            <p> Dont have an Account? <Link className="ml-2" to={"/register"}> <strong> Create one </strong></Link> </p>
          </Form>
        </div>
      </div>
    </div>
  );
};

export default ResetForm;
